module.exports = __webpack_public_path__ + "img/avatarArtboard-7.5f4118be.svg";